import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading_territorial: false,
    loading_track: false,
    loading_channel: false,
    loading_category: false,
    loading_video: false,
    loading: false,
    loading_track_campaign: false,
    date_range: [],
    category: [],
    info: [],
    period: [],
    territorial: [],
    track: [],
    track_campaign: [],
    channel: [],
    video: [],
    artist_label: null,
    artist_track: null,
    order_column: 'campaign_track_start',
    order_type: 'desc',
    LineChartSett: {
      width: 'auto',
      height: 322,
      is3D: true,
      colors: ['#2e2749', '#e80021'],
      curveType: 'none',
      isStacked: 'relative',
      fontSize: 12,
      fontName: 'Nunito Regular',
      vAxis: {
        maxAlternation: 4,
        minorGridlines: {
          count: 15
        },
        minValue: 0,
        slantedText: true,
        slantedTextAngle: 70,
        gridlines: {
          count: 15
        },
        textStyle: {
          fontSize: 12
        },
        format: 'short',
        viewWindowMode: 'pretty'
      },
      hAxis: {
        format: 'short',
        viewWindowMode: 'pretty',
        textStyle: {
          fontSize: 12
        },
        color: '#000'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 16,
          isHtml: true
        },
        showColorCode: true
      },
      lineWidth: 2.3,
      legend: {
        position: 'bottom',
        textStyle: {
          color: '#000',
          fontSize: 14,
          bold: true
        }
      },
      chartArea: {
        left: '7%',
        top: '5%',
        width: '100%',
        height: '75%'
      }
    },
    PieChartSett: {
      width: 'auto',
      height: 330,
      is3D: false,
      pieSliceText: 'value',
      fontName: 'Nunito Bold',
      pieSliceTextStyle: {
        color: '#fff',
        fontSize: 15
      },
      legend: 'none',
      pieHole: 0.5,
      chartArea: {
        width: '90%',
        height: '90%'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 14
        },
        showColorCode: true
      },
      colors: [
        '#FC0000',
        '#FF7F00',
        '#FEE507',
        '#09FB19',
        '#00CC0E',
        '#25A776',
        '#00D5D5',
        '#015C8F',
        '#0606F9',
        '#64289E',
        '#AD0AFC',
        '#F906E1',
        '#B6B0BF',
        '#868292',
        '#605677'
      ]
    },
    ColumnChart: {
      width: 'auto',
      height: 400,
      colors: ['#2e2749', '#554c78', '#a39dbd'],
      fontName: 'Nunito Regular',
      legend: { position: 'bottom', maxLines: 5 },
      bar: { groupWidth: '75%' },
      isStacked: true,
      chartArea: {
        left: '0',
        top: '4%',
        width: '100%',
        height: '70%'
      }
    },
    GeoChartSett: {
      width: 'auto',
      height: 'auto',
      is3D: true,
      fontName: 'Nunito Regular',
      legend: 'none',
      chartArea: {
        right: '0',
        top: '0',
        width: '70%'
      },
      tooltip: {
        textStyle: {
          color: '#000',
          fontSize: 15
        },
        showColorCode: true
      },
      colors: [
        '#F906E1',
        '#AD0AFC',
        '#0606F9',
        '#07F9F9',
        '#09FB19',
        '#FEE507',
        '#FF7F00',
        '#FC0000'
      ]
    }
  },

  mutations: {
    setLoadingTerritorial(state, payload) {
      state.loading_territorial = payload
    },
    setLoadingTrack(state, payload) {
      state.loading_track = payload
    },
    setLoadingTrackCampaign(state, payload) {
      state.loading_track_campaign = payload
    },
    setLoadingChannel(state, payload) {
      state.loading_channel = payload
    },
    setLoadingCategory(state, payload) {
      state.loading_category = payload
    },
    setLoadingVideo(state, payload) {
      state.loading_video = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDateRange(state, payload) {
      state.date_range = [payload.start, payload.end]
    },
    setCategoryData(state, payload) {
      state.category = payload
    },
    setInfoData(state, payload) {
      state.info = payload
    },
    setInfoPeriodData(state, payload) {
      state.period = payload
    },
    setTerritorialData(state, payload) {
      state.territorial = payload
    },
    setTrackData(state, payload) {
      state.track = payload
    },
    setTrackCampaignData(state, payload) {
      state.track_campaign = payload
    },
    setChannelData(state, payload) {
      state.channel = payload
    },
    setVideoData(state, payload) {
      state.video = payload
    },
    setSelectedArtist(state, payload) {
      state.artist_label = payload
    },
    setSelectedTrack(state, payload) {
      state.artist_track = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    }
  },

  actions: {
    readCategoryData({ commit, state }) {
      commit('setLoadingCategory', true)
      axios.artist
        .get('category', {
          params: {
            artist: state.artist_label !== null ? state.artist_label.id : null,
            track: state.artist_track !== null ? state.artist_track.id : null
          }
        })
        .then(r => {
          commit(
            'setCategoryData',
            r.data.data.sort((a, b) => b.video - a.video)
          )
          commit('setLoadingCategory', false)
        })
        .catch(() => {
          commit('setLoadingCategory', false)
        })
    },

    readInfo({ commit, state }) {
      commit('setLoading', true)
      axios.artist
        .get('info', {
          params: {
            artist: state.artist_label !== null ? state.artist_label.id : null,
            track: state.artist_track !== null ? state.artist_track.id : null
          }
        })
        .then(r => {
          commit('setInfoData', r.data.data[0])
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readPeriodInfo({ commit, state }) {
      commit('setLoading', true)
      axios.artist
        .get('info/period', {
          params: {
            artist: state.artist_label !== null ? state.artist_label.id : null,
            track: state.artist_track !== null ? state.artist_track.id : null
          }
        })
        .then(r => {
          commit('setInfoPeriodData', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readTerritorial({ commit, state }) {
      commit('setLoadingTerritorial', true)
      axios.artist
        .get('territorial', {
          params: {
            artist: state.artist_label !== null ? state.artist_label.id : null,
            track: state.artist_track !== null ? state.artist_track.id : null
          }
        })
        .then(r => {
          commit(
            'setTerritorialData',
            r.data.data.sort((a, b) => b.video - a.video)
          )
          commit('setLoadingTerritorial', false)
        })
        .catch(() => {
          commit('setLoadingTerritorial', false)
        })
    },

    readTrack({ commit, state }, order) {
      commit('setLoadingTrack', true)
      axios.artist
        .get('track', {
          params: {
            order_column: order.column,
            order_type: order.type,
            artistId: state.artist_label !== null ? state.artist_label.id : null,
            trackId: state.artist_track !== null ? state.artist_track.id : null,
            page_size: 5
          }
        })
        .then(r => {
          commit('setTrackData', r.data.data.data)
          commit('setLoadingTrack', false)
        })
        .catch(() => {
          commit('setLoadingTrack', false)
        })
    },

    readTrackCampaign({ commit, state }) {
      commit('setLoadingTrackCampaign', true)
      axios.artist
        .get('track/campaign', {
          params: {
            track: state.artist_track !== null ? state.artist_track.id : null,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          commit('setTrackCampaignData', r.data.data)
          commit('setLoadingTrackCampaign', false)
        })
        .catch(() => {
          commit('setLoadingTrackCampaign', false)
        })
    },

    readTopChannel({ commit, state }, order) {
      commit('setLoadingChannel', true)
      axios.artist
        .get('channel', {
          params: {
            order: order,
            artist: state.artist_label !== null ? state.artist_label.id : null,
            track: state.artist_track !== null ? state.artist_track.id : null
          }
        })
        .then(r => {
          commit('setChannelData', r.data.data)
          commit('setLoadingChannel', false)
        })
        .catch(() => {
          commit('setLoadingChannel', false)
        })
    },

    readTopVideo({ commit, state }, order) {
      commit('setLoadingVideo', true)
      axios.artist
        .get('video', {
          params: {
            order: order,
            artist: state.artist_label !== null ? state.artist_label.id : null,
            track: state.artist_track !== null ? state.artist_track.id : null
          }
        })
        .then(r => {
          commit('setVideoData', r.data.data)
          commit('setLoadingVideo', false)
        })
        .catch(() => {
          commit('setLoadingVideo', false)
        })
    }
  },

  getters: {
    category_chart: state => {
      let result = []
      if (state.category) {
        result = [['Task', 'Hours per Day']]
        state.category.map(s => {
          result.push([s.category, Number(s.video)])
        })
      }
      return result
    },
    period_chart: state => {
      let views = [['date', 'Views']],
        subscribers = [['date', 'Subscribers']],
        videos = [['date', 'Videos']],
        previews = [['date', 'Previews']],
        result = {}
      if (state.period && state.period.length > 0) {
        state.period.map(s => {
          let date = new Date(s.created_at)
          let year = date
            .getFullYear()
            .toString()
            .substr(-2)
          let month = date.toLocaleString('default', { month: 'short' })
          let day = date.getDate().toString()
          let newDate = month + '-' + day + '-' + year
          views.push([newDate, Number(s.views)])
          subscribers.push([newDate, Number(s.subscribers)])
          videos.push([newDate, Number(s.video)])
          previews.push([newDate, Number(s.previews)])
        })
        result = {
          views: views,
          subscribers: subscribers,
          videos: videos,
          previews: previews
        }
        return result
      } else {
        result = {}
        return result
      }
    },
    territorial_chart: state => {
      let result = [['Country', 'Popularity']]
      if (state.territorial && state.territorial.length > 0) {
        state.territorial.map(s => {
          result.push([s.name, Number(s.video)])
        })
      }
      return result
    },
    track_chart: state => {
      let result = []
      if (state.track) {
        result = [['Track', 'Views', 'Subscribers', 'Previews']]
        state.track.map(s => {
          result.push([
            s.title,
            Number(s.views),
            Number(s.subscribers),
            Number(s.previews)
          ])
        })
      }
      return result
    }
  }
}

function dateFormat(date) {
  let new_date = new Date(date)
  new_date = new_date
    .toDateString()
    .slice(3, 15)
    .toUpperCase()
  let arr = new_date.split(' ')
  arr = arr.filter(function(str) {
    return /\S/.test(str)
  })
  return arr.join('-')
}
